@if (!edit){
<div class="d-flex w-100 profile-detail-row align-items-center">
  <p>
    {{ title | translate }}
  </p>
  <span [innerHTML]="control.value"></span>
</div>
} @else {
<p class="rightHeadings mt-3">
  {{ title | translate }}
  @if(required){<span class="text-danger">*</span>}
</p>
<div class="rich-text">
  <div>
    <div class="NgxEditor__Wrapper">
      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
      <ngx-editor
        [editor]="editor"
        [(ngModel)]="html"
        [formControl]="control"
        placeholder="{{
          placeholder !== undefined ? (placeholder | translate) : ''
        }}"
        class="w-100"
      ></ngx-editor>
    </div>
  </div>
</div>
}
